import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export const useNodeAnimations = (ref, animationName, animationCount) => {
  const $ = _c(5);
  let t0;
  if ($[0] !== ref) {
    t0 = () => {
      if (ref.current) {
        const animation = ref.current.style.animation;
        ref.current.style.animation = "none";
        ref.current.style.animation = animation;
      }
    };
    $[0] = ref;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== animationCount || $[3] !== ref) {
    t1 = [animationCount, ref];
    $[2] = animationCount;
    $[3] = ref;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!animationName) {
    return null;
  }
  const animation_0 = `${animationName} 0.3s ease-in-out`;
  return animation_0;
};